<template>
  <div class="page-wrap">
    <tabs ref="tabs" @choose="choose" @plateChoose="plateChoose" :selectId="selectId"></tabs>
    <template v-if="list.length"><list class="list-item" v-for="v in list" :key="v.id" :item="v" @look="handLook"></list></template>
    <div v-else class="no-data">暂无数据</div>
    <div class="pagenation">
      <el-pagination
      background
      layout="prev, pager, next,jumper,total"
      :page-size="page.pageSize"
      :current-page="page.pageNo"
      @current-change="handleCurrentChange"
      :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import List from '@/views/components/list'
import { getLcWeb } from '@/api/lc_web'
import tabs from './com/tabs'
import { cloneDeep } from 'lodash'
export default {
  data () {
    return {
      list: [],
      total: 0,
      wbsChildCategoryId: null, // 二级分类
      wbsCategoryId: null,
      page: {
        pageSize: 20,
        pageNo: 1
      },
      selectId: this.$route.query.id ? this.$route.query.id : -1
    }
  },
  components: {
    List,
    tabs
  },
  mounted () {
    let keyword = ''
    if (this.$route.params && this.$route.params.keyword) {
      keyword = this.$route.params.keyword
    }
    this.getType(keyword)
  },
  methods: {
    // 列表查询
    getList (val) {
      // const category = this.$store.state.user.cateId
      const obj = {
        name: 'lc.market.content.listPage',
        data: {
          wbsCategoryId: this.wbsCategoryId,
          wbsChildCategoryId: this.wbsChildCategoryId,
          start: this.page.pageNo,
          limit: this.page.pageSize,
          searchParam: val
        }
      }
      getLcWeb(obj).then(res => {
        this.total = res.results ? res.results : 0
        if (res.code === 0) {
          this.list = res.rows ? res.rows : []
          if (val) {
            this.$emit('clear')
          }
        } else {
          this.$showError(res.msg)
        }
      })
    },
    // 分类信息查询
    async getType (keyword) {
      if (this.$route.query.id) {
        this.selectId = this.$route.query.id
        this.wbsCategoryId = this.$route.query.id
      }
      const obj = {
        name: 'lc.market.category.list',
        data: {
          parentId: this.parentId
        }
      }
      const res = await getLcWeb(obj)
      if (res.code === 0) {
        const temp = res.value ? res.value : []
        let tabsList = cloneDeep(temp)
        tabsList = tabsList.filter(v => v.parentId === null)
        this.$refs.tabs.typeList = tabsList
        this.getList(keyword)
      } else {
        this.$showError(res.msg)
      }
    },
    async getSecondary (id) {
      const param = id ? { parentId: id } : {}
      const obj = {
        name: 'lc.market.category.list',
        data: param
      }
      const res = await getLcWeb(obj)
      if (res.code === 0) {
        this.$refs.tabs.secondList = res.value ? res.value : []
        this.getList()
      } else {
        this.$showError(res.msg)
      }
    },
    // 根据分类查询列表
    choose (id) {
      this.wbsCategoryId = id
      if (id) {
        this.getSecondary(id)
      } else {
        this.wbsCategoryId = null
        this.wbsChildCategoryId = null
        this.$refs.tabs.secondList = []
      }
      this.getList()
    },
    // 模块查询
    plateChoose (id) {
      this.wbsChildCategoryId = id || null
      this.getList()
    },
    // 改变当前分页
    handleCurrentChange (val) {
      val = Number(val)
      if (val === 0 || val > this.total) {
        return
      }
      this.page.pageNo = val
      this.getList()
    },
    /* 查看详情 */
    handLook (val) {
      this.$router.push({
        name: 'marketing',
        query: {
          id: val.id
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.search {
 width:350px;
}
.list-wrap{
  flex:1;
  width:100%;
}
.list-item{
  width:calc((100% - 72px) / 4);
}
.list-item:nth-child(4n+5){
  margin-right:0;
  padding-right:0;
}
.pagenation{
  text-align:right;
}
.pagenation ::v-deep .el-pagination__jump {
  margin-right:10px;
}
.no-data{
  text-align:center;
  padding: 100px 0;
}
</style>
